// COMPOSITION AUTHORITY BOUNDARY (frontend mirror of developmental_writing_controller.compose_intentional):
// the Composition workspace (ComposeUnit: writing area, the engine's reading, reply box, paragraph-function map) appears for a
// paragraph ONLY when refinement of it was entered INTENTIONALLY — by the student (the panel's own open / turn: entered_by
// "student") or by the developmental controller's judgment ("developmental_controller"). A `student_prose` entry is the old
// heuristic's recognition record (placed unit + ≥3 sentences + ≥50 words): writing a paragraph ≠ asking to refine it.
export const INTENTIONAL_COMPOSE_ENTRY = ["student", "developmental_controller"];

export const intentionalEntry = (entry) =>
  !!entry && typeof entry === "object" && entry.status === "composing" && INTENTIONAL_COMPOSE_ENTRY.includes(entry.entered_by || "student");

// the registry as the views may see it: intentional entries only (a recognized-prose record is invisible to the views)
export const intentionalCompose = (compose) =>
  Object.fromEntries(Object.entries(compose || {}).filter(([, e]) => intentionalEntry(e)));

export const intentionalFocus = (ot) => (ot && ot.compose_focus && intentionalEntry((ot.compose || {})[ot.compose_focus]) ? ot.compose_focus : null);
